import { useTranslation } from "react-i18next";

/**
 * Название юридического документа на языке интерфейса.
 *
 * Тела документов хранятся ТОЛЬКО на английском (декрет Д10: перевод
 * юридического текста — это его новая редакция, а не тот же документ другими
 * словами), поэтому `title` из API тоже всегда английский. Заголовок вокруг
 * текста к самому тексту не относится и обязан переводиться обычным i18n.
 *
 * Ключ из API остаётся фолбэком: документ, добавленный Legal Center'ом раньше,
 * чем в словарь попал его ключ, должен показать английское название, а не дыру.
 */
export function useDocumentTitle(): (key: string, fallback: string) => string {
	const { t, i18n } = useTranslation("common");
	return (key, fallback) => {
		const messageKey = `legal.documents.${key}.title`;
		return i18n.exists(messageKey, { ns: "common" }) ? t(messageKey) : fallback;
	};
}
